var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#80740E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41659 6.08334C11.6583 6.08334 13.6033 7.3475 14.5808 9.20084C15.5616 7.81917 17.1749 6.91667 18.9999 6.91667H21.9166V9C21.9166 11.9917 19.4916 14.4167 16.4999 14.4167H15.2499V15.25H19.4166V21.0833C19.4166 22.0042 18.6708 22.75 17.7499 22.75H11.0833C10.1624 22.75 9.41659 22.0042 9.41659 21.0833V15.25H13.5833V13.5833H11.9166C8.69492 13.5833 6.08325 10.9717 6.08325 7.75V6.08334H9.41659ZM17.7499 16.9167H11.0833V21.0833H17.7499V16.9167ZM20.2499 8.58334H18.9999C16.9291 8.58334 15.2499 10.2625 15.2499 12.3333V12.75H16.4999C18.5708 12.75 20.2499 11.0708 20.2499 9V8.58334ZM9.41659 7.75H7.74992C7.74992 10.0508 9.61575 11.9167 11.9166 11.9167H13.5833C13.5833 9.61584 11.7174 7.75 9.41659 7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/Growth.c76cf27a27198310718abad3ffb56f38.svg";
export { ForwardRef as ReactComponent };